import sections from "../data/links.json";
import Branch from "./Branch";
import Root from "./Root";

const Shrub = () => {
    return (
        <div data-testid="Shrub" className="shrub">
            <Root />

            {/* {sections.map((link, index) => {
                return <Branch key={index} index={index} branchInfo={link} />
            })} */}

            {sections.map((section, indexi) => {
                return (
                    <div key={indexi}>
                        {section.title && <h3>{section.title}</h3>}

                        {section.links.map((link, indexj) => {
                            return <Branch key={indexj} index={indexj} branchInfo={link} />
                        })}
                    </div>
                )
            })}
        </div>
    )
}

export default Shrub;